import { render, staticRenderFns } from "./CourseSideNav.vue?vue&type=template&id=415365c0&scoped=true&"
import script from "./CourseSideNav.vue?vue&type=script&lang=js&"
export * from "./CourseSideNav.vue?vue&type=script&lang=js&"
import style0 from "./CourseSideNav.vue?vue&type=style&index=0&id=415365c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415365c0",
  null
  
)

export default component.exports